var examen = {
    publicationId: null,
    examenId: null,
    calificationId: null,
    numberQuestion : 1,
    initCalification: function(elem) {
        $(elem).addClass("btn-disable");
        $.ajax({
            url : '/es/examen/init-calification', 
            type : 'POST',
            dataType : 'json',
            data : {examenId: examen.examenId},
            success : function(data) {
                if(data.success) {
                    examen.calificationId = data.data.id;
                    examen.next(1, elem);
                } else {
                    $(elem).removeClass("btn-disable");
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: data.message,
                      })
                }
            }  
        });
    },
    next: function(numberQuestion, elem) {
        $.ajax({
            url : '/es/examen/question', 
            type : 'POST',
            dataType : 'json',
            data : {
                examenId: examen.examenId, 
                numberQuestion : numberQuestion,
                calificationId : examen.calificationId
            },
            success : function(data) {
                $('#idDivExamen .btn-disable').prop('disabled', false);
                $('#idDivExamen .btn-disable').text('Responder');
                if(data.success) {
                    $('#idDivExamen').html(data.html);
                    setTimeout(function(){
                        examen.changeFormExam();
                        //examen.validateFormIE();
                    }, 500);
                }
            }  
        });
    },  
    success: function(type) { 
        $.ajax({
            url : '/es/examen/success', 
            type : 'POST',
            dataType : 'json',
            data : {
                examenId: examen.examenId, 
                calificationId : examen.calificationId,
                type : type
            },
            success : function(data) {
                $('#idDivExamen .btn-disable').prop('disabled', false);
                $('#idDivExamen .btn-disable').text('Responder');
                if(data.success) {
                    $('#idDivExamen').html(data.html);
                }
            }  
        });
    },
    summary: function() {
        $.ajax({
            url : '/es/examen/summary', 
            type : 'POST',
            dataType : 'json',
            data : {
                examenId: examen.examenId, 
                calificationId : examen.calificationId
            },
            success : function(data) {
                if(data.success) {
                    $('#idDivExamen').html(data.html);
                }
            }  
        });
    },
    qualify : function() {
		$('#idFormCalificaciones').validate({
            rules:{
                alternative:{
                    required: true
                }
            },
            messages: {
                alternative:{
                    required: 'Seleccione una opción'
                }
            },
            submitHandler: function(form){
                
                $('.btn-exam-t').addClass('btn-disable');
                $('.btn-l-question').addClass('btn-disable');
                var params = $('#idFormCalificaciones').serialize();
                params += '&examenId=' + examen.examenId;
                params += '&numberQuestion=' + examen.numberQuestion;
                params += '&calificationId=' + examen.calificationId;
                $('#idDivExamen .btn-disable').prop('disabled', true);
                $('#idDivExamen .btn-disable').text('Procesando');
                $.ajax({
                    url : '/es/examen/qualify', 
                    type : 'POST',
                    dataType : 'json',
                    data : params,
                    success : function(data) {
                        if(data.success) {
                            if(data.data.type == 'continue') {
                                examen.numberQuestion = data.data.next;
                                examen.next(data.data.next);
                            } else if(data.data.type == 'success') {
                                examen.success('success');
                            } else if(data.data.type == 'error') {
                                examen.success('error');
                            }
                        } else {
                            $('#idDivExamen .btn-disable').prop('disabled', false);
                            $('#idDivExamen .btn-disable').text('Responder');
                            Swal.fire({
                                type: 'error',
                                title: 'Oops...',
                                text: data.message,
                              })
                        }
                    }  
                });

            }
        });
	},

    qualifyForm: function(){
        var params = $('#idFormCalificacionesP').serialize();
        params += '&examenId=' + examen.examenId;
        params += '&numberQuestion=' + examen.numberQuestion;
        params += '&calificationId=' + examen.calificationId;
        console.log(params);
        $('#idDivExamen .btn-disable').prop('disabled', true);
        $('#idDivExamen .btn-disable').text('Procesando');
        $.ajax({
            url : '/es/examen/qualify', 
            type : 'POST',
            dataType : 'json',
            data : params,
            success : function(data) {
                if(data.success) {
                    if(data.data.type == 'continue') {
                        examen.numberQuestion = data.data.next;
                        examen.next(data.data.next);
                    } else if(data.data.type == 'success') {
                        examen.success('success');
                    } else if(data.data.type == 'error') {
                        examen.success('error');
                    }
                } else {
                    $('#idDivExamen .btn-disable').prop('disabled', false);
                    $('#idDivExamen .btn-disable').text('Responder');
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: data.message,
                    })
                }
            }  
        });
    },

    changeFormExam: function(){
        $('#idFormCalificaciones input, #idFormCalificaciones textarea').on('keyup blur change', function () {
            if ($(this).val().length > 0) {
                $('.btn-exam-t').removeClass('btn-disable');
            }else{
                $('.btn-exam-t').addClass('btn-disable');
            }
            /*if ($('#idFormCalificaciones').valid()) {

                $('.btn-exam-t').removeClass('btn-disable');
            } else {
                $('.btn-exam-t').addClass('btn-disable');
            }*/
        });
    },
    validateFormIE: function(){
        if($("#idFormCalificacionesP").length){


            /*$('.form-question input[type="text"], .form-question textarea').on('focus', function() {
                $(this).removeClass('input-error');
            });

            var validateF = false;

            $('.form-question .btn-l-question').on('click', function(e) {

                console.log("Click");
                
                $('.form-question').find('input[type="text"], textarea, input[type="radio"]:checked').each(function() {
                    if( $(this).val() == "" ) {
                        $(this).addClass('input-error');
                        validateF = false;
                    }
                    else {
                        $(this).removeClass('input-error');
                        validateF = true;
                    }
                });
                
                setTimeout(function(){
                    if(validateF){
                        $('.form-question').submit();
                        examen.qualifyForm();
                    } 
                }, 300);

            });*/
            /*$('.form-question .btn-l-question').on('click', function(e) {
                console.log("click");
                $('.form-question').on('submit', function(e) {
                    console.log("Provando");
                    return true;
                    examen.qualifyForm();
                });
            });*/

            $('.form-question').on('submit', function(e) {
                if(!this.checkValidity()){
                    return false;
                }else{
                    examen.qualifyForm();  
                }
            });
        }
    }
}
